import React from "react";
import { formatArrivalDate, TimeOfDay } from "@greeter/date";
import { Clock } from "@greeter-venue/components/Clock/Clock";
import { BookingId } from "@greeter/matter";

import css from "./BookingListItemContent.module.scss";

export type BookingListItemContentProps = {
  name: string;
  arrivalDate: Date;
  bookingId: string;
  className?: string;
  style?: React.CSSProperties;
};
export function BookingListItemContent({
  name,
  arrivalDate,
  bookingId = "0000",
  ...props
}: BookingListItemContentProps) {
  return (
    <div className={css.BookingListItemContent} {...props}>
      <div>
        <Clock time={TimeOfDay.fromDate(arrivalDate)} />
        <div>{formatArrivalDate(arrivalDate)}</div>
      </div>
      <div className={css.Name}>{name}</div>
      <div className={css.Id}>
        <BookingId id={bookingId} />
      </div>
    </div>
  );
}
